import { theme } from 'antd'
import { useTranslation } from 'react-i18next'

// The "Drop files here" overlay shown while files are dragged over an
// attachment dropzone. Shared by every outbound-attachment surface (operator +
// customer composers and new-conversation forms) so the visual feedback is
// identical everywhere. Render it as the last child of a
// position:relative container; it fills that container and ignores pointer
// events so it never swallows the drop.
export function AttachmentDropOverlay() {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `${token.colorPrimaryBg}cc`,
        borderRadius: token.borderRadiusLG,
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      <div
        style={{
          padding: '12px 24px',
          backgroundColor: token.colorBgElevated,
          borderRadius: token.borderRadiusLG,
          boxShadow: token.boxShadowSecondary,
          color: token.colorPrimary,
          fontWeight: 500,
        }}
      >
        {t('frontend:chatwoot.attachment.dropFilesHere')}
      </div>
    </div>
  )
}
